import React, { useState, useEffect } from "react";
import InboundMcpToolModal from './InboundMcpToolModal';
import ConfirmationModal from './ConfirmationModal';
import api from '../../../../../../../api';
import './DataConnectPage.css'
import {
    Message,
    Table,
    Header,
    Divider,
} from "semantic-ui-react";

const InboundMcpToolsPage = (props) => {
    const [modalStatus, setModalStatus] = useState(false);
    const [showErrortype, setshowErrortype] = useState({type:"",title:"",message:""});
    const [modalOpen, setModalOpen] = useState(false);
    const [tools, updateTools] = useState([]);
    const [selectedTool, setSelecteTool] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        id: null,
        name: "",
        description: "",
        server_url: "",
        protocol: "shttp",
        headers: []
    });

    useEffect(() => {
        loadMcpTools();
    }, []);

    useEffect(() => {
        setTimeout(() => {
            setshowErrortype({type:"",title:"",message:""})
        }, 7000);
    }, [showErrortype]);

    const loadMcpTools = () => {
        setIsLoading(true);
        api.InboundMcpTooling.getMcpTools(atob(props.workspace_id)).then((res) => {
            if(res && res.tools){
                updateTools(res.tools);
            }
            setIsLoading(false);
        }).catch((err) => {
            console.log(err);
            setshowErrortype({type:"negative",title:"Error",message:"Failed to load inbound MCP tools."})
            setIsLoading(false);
        });
    }

    const addNewToolOpenModal = () => {
        setFormData({
            id: null,
            name: "",
            description: "",
            server_url: "",
            protocol: "shttp",
            headers: []
        });
        setModalStatus(true);
    }

    const editformdata = (tool) => {
        setFormData({
            id: tool.id,
            name: tool.name,
            description: tool.description,
            server_url: tool.server_url,
            protocol: tool.protocol,
            headers: []
        });
        setModalStatus(true);
    }

    const deleteformdata = () => {
        let id = selectedTool;
        setIsLoading(true);
        api.InboundMcpTooling.deleteMcpTool(id).then((res) => {
            if(res && res.success){
                loadMcpTools();
                setshowErrortype({type:"positive",title:"Success!",message:"Inbound MCP tool deleted successfully."})
            } else {
                setshowErrortype({type:"negative",title:"Failed!",message:"Something went wrong."})
                setIsLoading(false);
            }
            setModalOpen(false);
        }).catch(() => {
            setshowErrortype({type:"negative",title:"Failed!",message:"Failed to delete tool."})
            setModalOpen(false);
            setIsLoading(false);
        });
    }

    const messageAlert = () => {
        if(showErrortype.title !== ""){
            return (
                showErrortype.type === 'negative' ?
                <Message negative>
                    <Message.Header>{showErrortype.title}</Message.Header>
                    <p>{showErrortype.message}</p>
                </Message> :
                <Message positive>
                    <Message.Header>{showErrortype.title}</Message.Header>
                    <p>{showErrortype.message}</p>
                </Message>
            )
        } else {
            return <></>
        }
    }

    const openModal = (tool) => {
        setSelecteTool(tool.id);
        setModalOpen(true);
    };

    const closeModal = () => {
        setSelecteTool(null);
        setModalOpen(false);
    };

    return (
        <>
        <div style={{ margin: "0 auto", maxWidth: "90%", position: "relative" }}>
            {isLoading && <div className="ui loading form"></div>}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                <Header as="h3" style={{ margin: 0 }}>
                    MCP Tools (Inbound)
                </Header>
                <button
                    color="blue"
                    className="btn linear-gradient yr-submitbtn"
                    onClick={() => addNewToolOpenModal()}
                >
                    Add MCP Tool
                </button>
            </div>
            <Divider style={{ marginTop: "10px" }} />
            {messageAlert()}

            <Table celled compact style={{ tableLayout: "fixed", width: "100%" }}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell style={{ width: "5%" }}>Sno</Table.HeaderCell>
                        <Table.HeaderCell style={{ width: "30%" }}>Name</Table.HeaderCell>
                        <Table.HeaderCell style={{ width: "40%" }}>Server URL</Table.HeaderCell>
                        <Table.HeaderCell style={{ width: "10%" }}>Protocol</Table.HeaderCell>
                        <Table.HeaderCell style={{ width: "15%" }}>Actions</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {tools && tools.length > 0 && tools.map((tool, index) => (
                    <Table.Row key={tool.id}>
                        <Table.Cell>{index+1}</Table.Cell>
                        <Table.Cell style={{wordBreak: "break-word"}}>{tool.name}</Table.Cell>
                        <Table.Cell style={{wordBreak: "break-all"}}>{tool.server_url}</Table.Cell>
                        <Table.Cell>{tool.protocol}</Table.Cell>
                        <Table.Cell>
                            <div style={{ display: "flex", gap: "10px" }}>
                                <button type="button" className="btn btn-icon" onClick={() => editformdata(tool)}>
                                    <i className="la la-edit blue" title="Edit"></i>
                                </button>
                                <button type="button" className="btn btn-icon" onClick={() => openModal(tool)}>
                                    <i className="la la-trash red" title="Delete"></i>
                                </button>
                            </div>
                        </Table.Cell>
                    </Table.Row>
                    ))}
                    {tools && tools.length === 0 && (
                    <Table.Row>
                        <Table.Cell colSpan="5" textAlign="center">
                            No inbound MCP tools found. Click "Add MCP Tool" to create one.
                        </Table.Cell>
                    </Table.Row>
                    )}
                </Table.Body>
            </Table>
        </div>

        <ConfirmationModal
            open={modalOpen}
            onClose={closeModal}
            onConfirm={deleteformdata}
        />

        {modalStatus && (
            <InboundMcpToolModal
                preformData={formData}
                open={modalStatus}
                onClose={() => setModalStatus(false)}
                onOpen={() => setModalStatus(true)}
                setshowErrortype={setshowErrortype}
                workspace_id={props.workspace_id}
                loadMcpTools={loadMcpTools}
            />
        )}
        </>
    );
};

export default InboundMcpToolsPage;
